import React, { useMemo } from "react";
import { useStore } from "../../../stores/store";

interface ZoomSliderProps {
  minZoom: number | undefined;
  maxZoom: number | undefined;
}

export default function ZoomSlider({
  minZoom = 1,
  maxZoom = 12,
}: ZoomSliderProps) {
  const { zoom, setZoom } = useStore();
  return (
    <div className="bg-white w-[32px] flex items-center esri-widget">
      <input
        style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          WebkitTransform: "rotate(180deg)",
        }}
        className="mx-auto my-1 bg-transparent"
        type="range"
        min={minZoom}
        max={maxZoom}
        step={1}
        value={zoom}
        onInput={(e: any) => { setZoom(parseInt(e.target.value)) }}
        list="tickmarks"
      />
      <datalist id="tickmarks" className="mr-2">
        {Array(maxZoom)
          .fill(1)
          .map((_, i) => {
            return <option key={i + 1} value={i + 1} />;
          })}
      </datalist>
    </div>
  );
}
